var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.7 70.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M45.49 1.72 33.64 4.9a6.34 6.34 0 0 1-3.18 0L18.22 1.71a6.4 6.4 0 0 0-3.28 0L3.29 4.84A2.41 2.41 0 0 0 1.5 7.17v41a2.41 2.41 0 0 0 3 2.33l10.57-2.84a6.5 6.5 0 0 1 3.33 0l12 3.23a6.3 6.3 0 0 0 3.23 0l12-3.23a6.5 6.5 0 0 1 3.34 0l8.83 2.38a3.8 3.8 0 0 0 4.78-3.67V8.25a3.8 3.8 0 0 0-2.84-3.67l-11-2.87a6.44 6.44 0 0 0-3.25.01M32.21 41.4v8.92m0-44.59v18.4M47.68 2.36v11.99M38.6 37.57a7.92 7.92 0 1 1 6.22 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.82,
    cy: 32.65,
    r: 14.93,
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m52.81 45.74 3.72 5.59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.49,
    height: 21.01,
    x: 58.92,
    y: 49.46,
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    rx: 3.25,
    transform: "rotate(-31.42 62.168 59.956)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m63.17 56.74-4.69 2.92M19.93 17.59c0 2.26-4.36 11.17-4.36 11.17s-4.35-8.91-4.35-11.17a4.22 4.22 0 0 1 4.35-4.08 4.22 4.22 0 0 1 4.36 4.08"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.57,
    cy: 17.71,
    r: 1.32,
    fill: "inherit"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6bd98097168dafb00b75951ccfd81baf.svg";
export { ForwardRef as ReactComponent };